// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Link, InputAdornment, Dialog, DialogContent, DialogActions, DialogContentText, CircularProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ButtonComponents from '../../commonComponents/ButtonComponents';
import { textColor } from '../../../utils/commonstyle';
import { useNavigate } from 'react-router-dom';
import { postLedgerConfiguration, fetchAccountData } from '../../../redux/slice/ledgerSlice';
import { useDispatch, useSelector } from 'react-redux';
import { generateGUID, numberToWords } from '../../../utils/formatUtils';
import { AppconfigName } from '../../../utils/config';
 
 
const AddFunds = () => {
    const configName = AppconfigName()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [amount, setAmount] = useState('');
    const [error, setError] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);

    const { accountResponse } = useSelector((state) => state.ledger); // Access the state from the store
    const { loginInvestorId : investorId, businessId } = useSelector((state) => state.user); // Access the state from the store

    useEffect(() => {
        if(businessId){
            dispatch(fetchAccountData(businessId));
        }else {
            dispatch(fetchAccountData(investorId))
        }
    }, [investorId, businessId]);
    const handleAddFunds = async () => {
        try {
            const newGUID = generateGUID();
            if (amount && !error) {
                const amt = amount.replaceAll(",", "")
                const payload = {
                    investorId: investorId ? investorId : businessId,
                    amount: Number(amt),
                    action: "deposit_money",
                    IdempotencyKey: newGUID,
                    inv_Acc_Id: accountResponse[0].InvAccId,
                };
                dispatch(postLedgerConfiguration(payload))
                setDialogOpen(true);
            }
        } catch (error) {
            console.error(error)
        }
    };

    const formatAmount = (value) => {
        // This function formats the number in US format with commas
        if (value === "") return "";  // Return empty string if no value
        const numberValue = parseFloat(value);
        return isNaN(numberValue) ? "" : new Intl.NumberFormat('en-US').format(numberValue);
    };
 
    const handleAmountChange = (e) => {
        let rawValue = e.target.value.replace(/[^0-9]/g, ''); // Remove any non-digit characters
        
        // Check if the value is valid (only digits, no decimals, no special characters)
        if (/^\d*$/.test(rawValue)) {
            if (rawValue === "") {
                setAmount("");  // Set the amount to empty if the value is deleted entirely
            } else {
                setAmount(formatAmount(rawValue));  // Format the value and update state
            }
            setError(parseInt(rawValue) <= 0);  // Check if the value is less than or equal to 0
        } else {
            setError(true); // Set error if the input is invalid (contains non-numeric characters)
        }
    };
 
    const handleCloseDialog = () => {
        setDialogOpen(false);
        setAmount(''); // Reset the amount after closing dialog
        navigate('/search');
    };

    return (
        <>
            {/* Success Dialog */}
            <Dialog open={dialogOpen} disableEscapeKeyDown aria-labelledby="success-dialog" maxWidth="sm" fullWidth>
                <DialogContent>
                    <Typography
                        align="center"
                        sx={{ color: '#FF5C39', mb: 1 }}
                    >
                        Funds Transfer Initiated
                    </Typography>
                    <DialogContentText align="center" sx={{ color: textColor.fontColor, mb: 2, fontSize: 13, fontWeight: 500 }}>
                        Fund transfer of ${amount} has been initiated. We will notify you once they are available in your xBid account. Meanwhile, explore our exclusive list of foreclosure properties!
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center', mb: 2, pt: 0 }}>
                    <ButtonComponents
                        label="Explore Properties"
                        onClick={handleCloseDialog}
                        variant="contained"
                        sx={{
                            backgroundColor: '#FF5C39',
                            color: '#fff',
                            '&:hover': { backgroundColor: '#e65232' },
                            px: 3,
                        }}
                    />
                </DialogActions>
            </Dialog>
 
            {/* Main Content */}
            <Box
                sx={{
                    maxWidth: { xs: "100%", md: "45%" },
                    mx: "auto",
                    my: 1.5,
                    display: "flex",
                    flexDirection: "column",
                    minHeight: { xs: "80vh", md: "33.2rem" },
                    bgcolor: "background.paper",
                    p: 4,
                    borderRadius: 2,
                    color: textColor.fontColor,
                    boxShadow: 2,
                }}
            > <Typography
                variant="h6"
                sx={{
                    fontSize: { xs: "1.25rem", md: 18 },
                    color: textColor.fontColor,
                    mb: 1,
                    textAlign: "center",
                }}
            >
                    You have successfully linked your bank account
                </Typography>
                <Typography sx={{ textAlign: "center", fontWeight: 400, fontSize: 13, px: 2, color: textColor.fontColor }}>You can now move funds into your {configName} account and place bids on our exclusive list of foreclosure properties.</Typography>
                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: '500',
                        fontSize: '0.875rem',
                        color: textColor.fontColor,
                        textAlign: 'left',
                        my: "19px",
                    }}
                >
                    Enter Amount
                </Typography>
                <Box sx={{ mb: 3 }}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        size="small"
                        // label="Amount"
                        placeholder="Amount"
                        value={amount}
                        onChange={handleAmountChange}
                        error={error}
                        helperText={error ? "Please enter a valid amount greater than $0" : ""}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Box
                                        sx={{
                                            marginBottom: 0,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            bgcolor: "#F8F8F8",
                                            height: 24,
                                            width: 15,
                                            borderRadius: '4px',
                                        }}
                                    >
                                        <Typography sx={{ fontSize: '1rem' }}>$</Typography>
                                    </Box>
                                </InputAdornment>
                            ),
                        }}
                        sx={{
                            // mb: 3,
                            height: 40,
                            mb: 0,
                            fontWeight: 700,
                            '& input':{
                                fontWeight:600,
                                bgcolor:"#fff",
                                ml:"2px",
                                pl:1,
                            },
                            '&.MuiFormControl-root label': {
                                color: textColor.fontColor,
                                // ml: 2
                            },
                            backgroundColor: '#f9f9f9',
                            '& .MuiOutlinedInput-root': {
                                '& fieldset': {
                                    borderColor: '#ccc',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#999',
                                },
                                '&.Mui-focused fieldset': {
                                    borderColor: '#666',
                                },
                            },
                            '& .MuiFormHelperText-root': {
                                fontSize: '0.75rem', // Ensure it matches the default height (or adjust based on your need)
                                height: 13, // Set the height of the helper text
                                marginTop: '4px', // Optionally adjust margin to align with the input box
                            },
                        }}
                    />
                    <Typography sx={{
                        fontSize: '12px',
                        color: textColor.fontColor,
                        fontWeight: 400,
                        mt: "3px",
                        height:10,
                        textAlign: 'left',
                         fontStyle: "italic"
                    }}>{numberToWords(amount.replace(/,/g, ''))}  {amount.replace(/,/g, '') > 0 && " dollars"}</Typography>
 
                </Box>
                <Box textAlign="center">
                    <ButtonComponents
                        label={"Add Funds"}
                        onClick={handleAddFunds}
                        disabled={!amount || error}
                        variant="contained"
                        sx={{
                            fontSize:14,
                            mb: 4,
                            color: '#fff',
                            my: "10px",
                            height:40,
                            with:40,
                            '&:hover': {
                                boxShadow : "none", backgroundColor:(!amount || error) ? "#9FA4AB" : '#e65232',
                                 color: "#FFF", fontSize:14,
                               },
                        }}
                    />
                </Box>
                <Box
                    sx={{
                        backgroundColor: '#FAFAFA',
                        p: 2,
                        mt: 14,
                        borderRadius: 1,
                        textAlign: "center"
                    }}
                >
                    <Typography variant="body2" sx={{ color: '#666' }}>
                    Explore our exclusive list of
                        <Link
                            href="/search"
                            underline="none"
                            sx={{ color: textColor.primaryColor, fontWeight: '600', textDecoration: "Underline" }}
                        >
                            foreclosure properties
                        </Link>
                    </Typography>
                </Box>
            </Box>
        </>
    );
};
 
export default AddFunds;